import React from "react";

export default ({ html }) => (
  <section className="section has-quote">
    <div className="container">
      <div className="columns is-mobile is-centered">
        <div className="is-10-tablet is-11-mobile column has-text-centered">
          <div
            className="is-quote"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>
      </div>
    </div>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/Quote.js